/**
 * SEARCH-PERF-169A — non-PII performance marks for search / bootstrap.
 * Never records query text or user identifiers.
 */
export type SearchPerfMark =
  | "app_boot_start"
  | "shell_visible"
  | "home_interactive"
  | "search_input_event"
  | "search_composition_start"
  | "search_composition_end"
  | "suggestion_request_start"
  | "suggestion_response"
  | "suggestion_painted"
  | "search_submit"
  | "search_results_received"
  | "search_results_painted";

const marks = new Map<string, number>();

export function markSearchPerf(name: SearchPerfMark, detail?: Record<string, number | string | boolean>): void {
  const t = typeof performance !== "undefined" ? performance.now() : Date.now();
  marks.set(name, t);
  try {
    performance.mark?.(`as_${name}`);
  } catch {
    /* ignore */
  }
  if (typeof window !== "undefined") {
    const w = window as Window & { __AS_SEARCH_PERF__?: Array<Record<string, unknown>> };
    w.__AS_SEARCH_PERF__ = w.__AS_SEARCH_PERF__ ?? [];
    if (w.__AS_SEARCH_PERF__.length < 200) {
      w.__AS_SEARCH_PERF__.push({ name, t, ...(detail ?? {}) });
    }
  }
}

export function measureSearchPerf(from: SearchPerfMark, to: SearchPerfMark): number | null {
  const a = marks.get(from);
  const b = marks.get(to);
  if (a == null || b == null) return null;
  return Math.max(0, b - a);
}

export function clearSearchPerfMarks(): void {
  marks.clear();
}
